module.exports = __webpack_public_path__ + "img/executive.2d4ea7a1.svg";